import { render } from "./ComplianceSettings.vue?vue&type=template&id=55721d8c&ts=true"
import script from "./ComplianceSettings.vue?vue&type=script&lang=ts"
export * from "./ComplianceSettings.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__